/* pg-frame-add */
(function(){
  if (window.pgFrameAdd) return; window.pgFrameAdd = 1;

  /* Both accessory upsells share this one row builder: the frame rides with
     the wall art, the spare case with the console. Prices are the LIVE ones -
     was = the variant's compareAtPrice - so the strike and the SAVE % are the
     same maths the cart itself shows. */
  var ACCS = [
    {
      key: 'frame',
      variant: 49688364613860,
      ownMark: '30x40cm-frame',
      withMark: 'lenticular-poster',
      img: 'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/blackframe_120x.png?v=1787284280',
      title: 'Add the matching frame',
      each: 'Add a frame for each print',
      sub: '30x40cm black wood grain',
      now: 1499, was: 2799
    },
    {
      key: 'case',
      variant: 49640879063268,
      ownMark: 'r36s-protective-case',
      withMark: 'handheld-game-console',
      img: 'https://cdn.shopify.com/s/files/1/0815/5706/1860/files/hf_20260810_234744_eb2ec102-427d-4c23-94f0-453e70014817.png?v=1786422962&width=120',
      title: 'Add a spare protective case',
      each: 'Add a spare case for each console',
      sub: 'One case already comes free',
      now: 1799, was: 2499   /* $17.99 since 2026-09-14 (was $13.99), the free one stays free */
    }
  ];
  window.pgAccFor = function(handle){
    var h = String(handle || '');
    for (var i = 0; i < ACCS.length; i++){ if (h.indexOf(ACCS[i].withMark) > -1) return ACCS[i]; }
    return null;
  };
  function moneyC(c){ return '$' + (c / 100).toFixed(2); }
  var FRAME_MARK = '30x40cm-frame';   /* still referenced by the YML trim below */

  /* ---------------- (1) the cart row ---------------- */
  function cartLines(){
    return document.querySelectorAll('#cart .l4ca:not(.in-panel) > li, body.template-cart .form-cart .l4ca:not(.in-panel) > li');
  }
  function cartHas(mark, paidOnly){
    var ls = cartLines();
    for (var i = 0; i < ls.length; i++){
      if (!ls[i].querySelector('a[href*="' + mark + '"]')) continue;
      /* paidOnly skips the auto-added FREE gift line - the spare-case offer
         must still show while only the free case is in the cart */
      if (paidOnly && ls[i].hasAttribute('data-pg-free')) continue;
      return true;
    }
    return false;
  }
  function offer(){
    var list = document.querySelector('#cart .l4ca:not(.in-panel), body.template-cart .form-cart .l4ca:not(.in-panel)');
    ACCS.forEach(function(cfg){
      /* one row per accessory, ever */
      var rows = document.querySelectorAll('.pg-frameoffer[data-acc="' + cfg.key + '"]');
      var row = rows[0] || null;
      for (var i = 1; i < rows.length; i++){
        if (rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
      }
      var wanted = !!list && cartHas(cfg.withMark) && !cartHas(cfg.ownMark, true) &&
        !document.querySelector('#cart .pg-unlock[data-pg-unlock*="' + cfg.withMark + '"]');
      if (!wanted){
        if (row && row.parentNode) row.parentNode.removeChild(row);
        return;
      }
      var save = Math.round((cfg.was - cfg.now) / cfg.was * 100);
      if (!row){
        row = document.createElement('div');
        row.className = 'pg-frameoffer';
        row.setAttribute('data-acc', cfg.key);
        row.innerHTML =
            '<img alt="" width="54" height="54" decoding="sync" src="' + cfg.img + '">'
          + '<div class="pg-frameoffer-t"><b>' + cfg.title + '</b>'
          + '<span class="pg-frameoffer-px"><s>' + moneyC(cfg.was) + '</s>' + moneyC(cfg.now)
          + '<span class="pg-frameoffer-sv">SAVE ' + save + '%</span></span>'
          + '<small>' + cfg.sub + '</small></div>'
          + '<button type="button" class="pg-frameoffer-add" data-v="' + cfg.variant + '">Add</button>';
      }
      var slot = document.querySelector('#cart #pg-unlock-slot');
      if (slot){
        if (row.parentNode !== slot) slot.appendChild(row);
      } else if (row.previousElementSibling !== list || row.parentNode !== list.parentNode){
        list.parentNode.insertBefore(row, list.nextSibling);
      }
    });
  }

  /* ---------------- (1b) one upsell at a time ----------------
     Candidates are the frame offer plus every pg-unlock row. The winner:
       1. any row the shopper is interacting with (open picker / focus)
       2. the frame offer, whenever it is on screen at all -- offer() has
          already established eligibility by then
       3. the row for the product whose cart quantity changed most recently
       4. the slot's own CSS order
     Everyone else gets the bench class. */
  var lastTouched = '', prevQty = null;
  function trackTouch(){
    var q = {};
    document.querySelectorAll('#cart .l4ca:not(.in-panel) > li').forEach(function(li){
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var inp = li.querySelector('input[type=number]');
      q[m[1]] = (q[m[1]] || 0) + (inp ? (parseInt(inp.value, 10) || 0) : 1);
    });
    if (prevQty){
      for (var h in q){
        if (!(h in prevQty) || q[h] > prevQty[h]) lastTouched = h;
      }
    }
    prevQty = q;
  }
  function focusOne(){
    /* Benching is OFF by request: each product in the cart shows its next
       bundle up, and the poster/console additionally show their accessory
       (frame / spare case). The bench class is only cleared now. */
    var cands = [];
    document.querySelectorAll('#cart .pg-unlock, #cart .pg-frameoffer').forEach(function(el){
      cands.push(el);
    });
    cands.forEach(function(el){ if (el.classList.contains('pg-upsell-bench')) el.classList.remove('pg-upsell-bench'); });
    if (true) return;
    if (cands.length < 2){
      cands.forEach(function(el){ el.classList.remove('pg-upsell-bench'); });
      return;
    }
    var winner = null, i, el;
    for (i = 0; i < cands.length && !winner; i++){
      el = cands[i];
      if (el.classList.contains('is-open') || el.contains(document.activeElement)) winner = el;
    }
    if (!winner){
      for (i = 0; i < cands.length && !winner; i++){
        if (cands[i].classList.contains('pg-frameoffer')) winner = cands[i];
      }
    }
    if (!winner && lastTouched){
      for (i = 0; i < cands.length && !winner; i++){
        if (cands[i].getAttribute('data-pg-unlock') === lastTouched) winner = cands[i];
      }
    }
    if (!winner){
      var best = null;
      for (i = 0; i < cands.length; i++){
        var o = parseInt(getComputedStyle(cands[i]).order, 10) || 0;
        if (best === null || o < best){ best = o; winner = cands[i]; }
      }
    }
    cands.forEach(function(c){ c.classList.toggle('pg-upsell-bench', c !== winner); });
  }

  /* ---------------- adding it ---------------- */
  /* Capture phase, delegated: the row above is re-created by the sweep below
     whenever the drawer rebuilds, so a listener bound to the button itself
     would not survive; and the drawer's own handlers call stopPropagation on
     clicks inside it. */
  var busy = false;
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('.pg-frameoffer-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;
    var was = btn.textContent;
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({items: [{id: parseInt(btn.getAttribute('data-v'), 10) || 49688364613860, quantity: 1}]})
    }).then(function(r){
      if (!r.ok) throw 0;
      btn.innerHTML = 'ADDED ✓';
      if (window.pgDrawerRefresh){
        try { return Promise.resolve(window.pgDrawerRefresh()); } catch(err){}
      }
    }).then(function(){
      /* the pgOpenCart() call that used to live here belonged to the product
         page tile -- adding from the cart means the cart is already open */
      setTimeout(function(){ busy = false; offer(); }, 400);
      setTimeout(function(){ btn.textContent = was; }, 2200);
    }).catch(function(){
      /* reverting silently to ADD reads as a dead button -- say it failed */
      btn.textContent = 'TRY AGAIN';
      setTimeout(function(){ btn.textContent = was; }, 2000);
      busy = false;
    });
  }, true);

  /* ---------------- (2) out of "You may also like" ---------------- */
  function ymlTrim(){
    document.querySelectorAll('.pgu-yml a, .pgu-yml-grid a').forEach(function(a){
      if ((a.getAttribute('href') || '').indexOf(FRAME_MARK) > -1){
        var card = a.closest('.pgu-yml-card') || a;
        card.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function pass(){ offer(); trackTouch(); focusOne(); ymlTrim(); }

  /* Event-driven, with a slow backstop -- the drawer rebuilds on every cart
     change and fires no event this section can subscribe to. Nothing in the
     pass touches the network. */
  if (window.MutationObserver){
    var t = null;
    new MutationObserver(function(){
      if (t) return;
      t = setTimeout(function(){ t = null; pass(); }, 120);
    }).observe(document.body, {childList: true, subtree: true});
  }
  setInterval(pass, 1500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pass);
  else pass();
})();
